import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useWizard } from 'rhf-wizard';
import MoonLoader from 'react-spinners/MoonLoader';
const Footer = () => {
    const { goToPreviousStep, isFirstStep, isLoading, stepNumber, setIsLoading, values, activeStep: { hidePrevious, disablePrevious, hideNext, disableNext, disableNextOnErrors, }, } = useWizard();
    const { formState: { isValid }, getValues, trigger, } = useFormContext();
    const isPreviousDisabled = disablePrevious || isLoading || isFirstStep;
    const isNextDisabled = disableNext || isLoading || (disableNextOnErrors && !isValid);
    const isSubmitStep = stepNumber === 7;
    //setIsLoading(true)
    return (React.createElement("div", { className: "modal-footer" },
        !hidePrevious && (React.createElement("button", { type: "button", disabled: isPreviousDisabled, className: "btn btn-secondary btn-icon", onClick: goToPreviousStep },
            React.createElement("i", { className: "fa-solid fa-chevron-left" }),
            " Go back")),
        isSubmitStep && (React.createElement("button", { type: "submit", disabled: isNextDisabled, className: "btn btn-cta btn-icon" },
            isLoading && React.createElement(MoonLoader, { size: 20 }),
            "Submit ",
            !isLoading && React.createElement("i", { className: "fa-solid fa-chevron-right" }))),
        !isSubmitStep && !hideNext && (React.createElement("button", { type: "submit", disabled: isNextDisabled, className: "btn btn-cta btn-icon", onClick: isNextDisabled ? () => { trigger(); } : undefined },
            isLoading && React.createElement(MoonLoader, { size: 20 }),
            "Next\u00A0Step",
            React.createElement("i", { className: "fa-solid fa-chevron-right" })))));
};
export default Footer;
